import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBuyCrypto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M5 13.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5H5Zm11 3a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.25 14.425a.754.754 0 0 1-.02-.07L2.516 7.66A1.75 1.75 0 0 1 3.779 5.53l11.784-3.013a1.75 1.75 0 0 1 2.13 1.262L19.09 9.25h.91c.966 0 1.75.784 1.75 1.75v9A1.75 1.75 0 0 1 20 21.75H6A1.75 1.75 0 0 1 4.25 20v-5.575ZM17.543 9.25l-1.304-5.1a.25.25 0 0 0-.304-.18L4.15 6.984a.25.25 0 0 0-.18.304L4.638 9.9C4.96 9.504 5.45 9.25 6 9.25h11.543ZM20.25 20a.25.25 0 0 1-.25.25H6a.25.25 0 0 1-.25-.25v-9a.25.25 0 0 1 .25-.25h14a.25.25 0 0 1 .25.25v9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBuyCrypto;
